import type { IResponseListData } from 'shared/api'

export type IReviewParams = {
  name: string
  image_url: string
  color: string
  title: string
  subtitle: string
  happy_subtitle: string
  unhappy_subtitle: string
  accounts: IReviewAccount[]
}

export type IResponseReview = {
  id: number
  uuid: string
  name: string
  organization_id: number
  owner_id: number
  short_url: string
  image_url: string
  color: string
  title: string
  subtitle: string
  happy_subtitle: string
  unhappy_subtitle: string
  created_at: string
  updated_at: string
}

export type IResponseCreateReviewParams = {
  data: IResponseReview
}

export type IReviewsListParams = {
  search?: string
  order?: 'asc' | 'desc'
  per_page?: number
  page?: number
}

export type IResponseListReview = IResponseReview & {
  rating: number
  happy_count: number
  unhappy_count: number
}

export type IResponseReviewsList = IResponseListData<IResponseListReview>

export type IReviewUploadImageParams = FormData

export type IResponseReviewUploadImage = {
  url: string
}

export type IReviewDeleteImageParams = {
  url: string
}

export type IResponseReviewDeleteImage = {
  deleted: boolean
}

export type IReviewAccount = {
  type: IReviewAccountType
  url_link: string
  button_name: string
  sort_order?: number
}

export enum EnumReviewAccount {
  google = 'Google',
  facebook = 'Facebook',
  yelp = 'Yelp',
  bbb = 'BBB',
  angi = 'Angi',
  capterra = 'Capterra',
  g2 = 'G2',
  custom = 'Custom link',
}

export type IReviewAccountType = keyof typeof EnumReviewAccount
